module.exports = __webpack_public_path__ + "img/A1-h-title2.4a295fb0.png";